import dayjs from 'dayjs'
import buildUrl from '~/utils/build-url'

export default {
  methods: {
    bookingUrl (venue, filters = {}) {
      if (! venue.booking_url) { return '' }
      const params = { aid: 381942 }
      if (filters.check_in) {
        const checkIn = dayjs(filters.check_in, 'DD/MM/YYYY')
        params.checkin_monthday = checkIn.date()
        params.checkin_month = checkIn.month() + 1
        params.checkin_year = checkIn.year()
      }
      if (filters.check_out) {
        const checkOut = dayjs(filters.check_out, 'DD/MM/YYYY')
        params.checkout_monthday = checkOut.date()
        params.checkout_month = checkOut.month() + 1
        params.checkout_year = checkOut.year()
      }
      if (filters.num_rooms) {
        params.no_rooms = Math.ceil(filters.num_rooms)
      }

      return buildUrl(venue.booking_url, params)
    },
  },
}
